/*
 * Cheap, NON-destructive text-hygiene checks (pure). Used to flag — never to
 * silently rewrite — the tell-tale artifact of a partial find/replace: the
 * template's trailing punctuation surviving next to the replacement's own, e.g.
 * find "…report" + replace "…not days." over a box that held "…report." leaves
 * "…not days.." with a red squiggle. We warn the agent so it re-does the edit as
 * a whole-text set_text; we do NOT edit the user's words on a heuristic.
 */

/** True if `text` contains a doubled '.' (not an ellipsis) or a doubled ',' — a
 * near-certain sign of a stray leftover from an incomplete find/replace. */
export function hasStrayDoublePunct(text: string): boolean {
  if (!text) return false;
  // Drop legitimate ellipses (runs of 3+ dots) before testing for a bare "..".
  const withoutEllipses = text.replace(/\.{3,}/g, "");
  return withoutEllipses.includes("..") || text.includes(",,");
}
